export default __webpack_public_path__ + "static/media/bg.3f85fd6e.png";